import React from "react"

import { StyledHeading, StandardContainer } from "../common"

export const Radio = ({ url }) => {
  return (
    <StandardContainer
      style={{
        maxWidth: "750px",
        width: "100%",
        margin: "auto",
        textAlign: "center",
      }}
    >
      <StyledHeading size="h2" style={{ color: "#4A4A4A" }}>
        The Tune Up Podcast
      </StyledHeading>
      <div
        className="podcastdotco-wrapper"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "45px",
        }}
      >
        <iframe
          title="the-tune-up-with-trev/jj-murray"
          dataTarget="the-tune-up-with-trev/jj-murray"
          src={url}
          frameborder="0"
          width="100%"
          scrolling="no"
          style={{ overflow: "hidden", maxWidth: "750px", height: "160px" }}
          className="podcastdotco-player podcastdotco-player--episode"
        ></iframe>
      </div>
    </StandardContainer>
  )
}
